// NotificationBell.jsx
import React, { useState, useRef, useEffect } from 'react';
import { Bell } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useNotifications } from '../../utils/NotificationContext';
import './NotificationBell.css'; // creá este archivo para estilos si querés

const NotificationBell = () => {
    // Cambiado unreadCount a unseenCount
    const { notifications, unseenCount, markAsRead, setIsBellDropdownOpen, markAllUnseenAsSeen } = useNotifications();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const bellRef = useRef(null);
    const navigate = useNavigate();

    // En NotificationBell.jsx
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (bellRef.current && !bellRef.current.contains(event.target)) {
                if (dropdownOpen) { // Solo si el dropdown estaba abierto
                    markAllUnseenAsSeen(); // Marcar como vistas al cerrar
                }
                setDropdownOpen(false);
                setIsBellDropdownOpen(false); // Cierra la campana
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [dropdownOpen, setIsBellDropdownOpen, markAllUnseenAsSeen]); // Asegúrate de agregar las dependencias

    const handleBellClick = () => {
        const newState = !dropdownOpen; // Toggle the dropdown state
        if (!newState && dropdownOpen) { // If the dropdown is being closed by clicking the bell
            markAllUnseenAsSeen(); // Mark all unseen notifications as seen
        }
        setDropdownOpen(newState);
        setIsBellDropdownOpen(newState);
    };

    const handleNotificationClick = (notification) => {
        // Marca como leída cuando el usuario hace clic en una notificación específica
        markAsRead(notification.id);
        if (notification.redirectPath) {
            navigate(notification.redirectPath);
        } else navigate("/usuario/notificaciones");
        setDropdownOpen(false);
        setIsBellDropdownOpen(false); // Cierra la campana después de hacer clic
    };

    return (
        <div className="notification-bell" ref={bellRef}>
            <div className="bell-icon" onClick={handleBellClick}> {/* Usar handleBellClick */}
                <Bell className="bell-svg" size={24} />
                {unseenCount > 0 && <span className="badge">{unseenCount}</span>} {/* Usar unseenCount */}
            </div>

            {dropdownOpen && (
                <div className="notification-panel">
                    {notifications.length === 0 ? (
                        <div className="empty">No hay notificaciones nuevas</div>
                    ) : (
                        notifications.map(n => (
                            <div key={n.id} className="dropdown-item" onClick={() => handleNotificationClick(n)}>
                                <div className="title">{n.title}</div>
                                {n.body && (
                                    <div className="body">
                                        {n.body.length > 60 ? `${n.body.substring(0, 60)}...` : n.body}
                                    </div>
                                )}
                            </div>
                        ))
                    )}
                    <div className="see-all" onClick={() => {
                        navigate('/usuario/notificaciones');
                        markAllUnseenAsSeen(); // Marcar como vistas al ir a "Ver todas"
                        setDropdownOpen(false);
                        setIsBellDropdownOpen(false);
                    }}>
                        Ver todas
                    </div>
                </div>
            )}
    </div>
    );};

export default NotificationBell;